import clsx from 'clsx';
import styles from './course.module.scss';
import { useEffect, useState } from 'react';
import { getRole } from '~/api/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faGripLines, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { getAllResultsOfClass } from '~/api/courses';
import { useParams } from 'react-router-dom';

const { default: CourseComponent } = require('~/components/Course');

const MainChild = () => {
    const { id } = useParams();
    const [role, setRole] = useState('normal');

    const [results, setResults] = useState([]);
    const [openTopics, setOpenTopics] = useState([]);

    const [textOfSearch, setTextOfSearch] = useState('');

    const handleChangeSearchInput = (event) => {
        setTextOfSearch(event.target.value);
    };

    const handleSubmitSearch = () => {};

    const lastAccess = (thoiGianCuoiCung) => {
        var thoiGianHienTai = new Date().getTime();
        var thoiGianCuoiCungDate = new Date(thoiGianCuoiCung);
        var thoiGianCuoiCungMiliGiay = thoiGianCuoiCungDate.getTime();
        var thoiGianDaTruyCap = thoiGianHienTai - thoiGianCuoiCungMiliGiay;

        var thoiGianDaTruyCapGiay = thoiGianDaTruyCap / 1000;

        if (thoiGianDaTruyCapGiay < 60) {
            return Math.floor(thoiGianDaTruyCapGiay) + ' giây trước';
        } else if (thoiGianDaTruyCapGiay < 3600) {
            return Math.floor(thoiGianDaTruyCapGiay / 60) + ' phút trước';
        } else if (thoiGianDaTruyCapGiay < 86400) {
            return Math.floor(thoiGianDaTruyCapGiay / 3600) + ' giờ trước';
        } else {
            return Math.floor(thoiGianDaTruyCapGiay / 86400) + ' ngày trước';
        }
    };

    const calcPercent = (point, scope) => {
        return (point / scope).toFixed(4) * 100;
    };

    const handleOpenTopic = (index) => {
        const updateOpens = [...openTopics];
        updateOpens[index] = !updateOpens[index];
        setOpenTopics(updateOpens);
    };

    useEffect(() => {
        setOpenTopics(new Array(100).fill(true));
        (async () => {
            const fetchRole = await getRole();
            setRole(fetchRole.body.role);
        })();
    }, []);

    useEffect(() => {
        (async () => {
            const fetchResults = await getAllResultsOfClass(id);
            setResults(fetchResults.body);
            console.log(fetchResults.body);
        })();
    }, [id]);

    return (
        <div>
            {role === 'student' && (
                <div className={clsx(styles.grades)}>
                    <div className={clsx(styles.gradesTable)}>
                        <div className={clsx(styles.gradesHead)}>
                            <div className={clsx('col-5')}>Title</div>
                            <div className={clsx('col-2', 'textCenter')}>Runtime</div>
                            <div className={clsx('col-2', 'textCenter')}>Memory</div>
                            <div className={clsx('col-1', 'textCenter')}>Score</div>
                            <div className={clsx('col-2', 'textEnd')}>Last time to submit</div>
                        </div>
                        <div className={clsx(styles.gradesBody)}>
                            {results &&
                                Object.keys(results).map((key, idxOfKey) => {
                                    return (
                                        <div className={clsx(styles.gradesTopic)}>
                                            <div
                                                className={clsx(styles.gradesTopicHeader)}
                                                onClick={() => handleOpenTopic(idxOfKey)}
                                            >
                                                <div className={clsx(styles.gradesTopicHeaderTitle)}>
                                                    <FontAwesomeIcon icon={faGripLines} />
                                                    <span>{key}</span>
                                                </div>
                                                <div className={clsx(styles.gradesTopicHeaderDropdown)}>
                                                    {openTopics[idxOfKey] && <FontAwesomeIcon icon={faAngleUp} />}
                                                    {!openTopics[idxOfKey] && <FontAwesomeIcon icon={faAngleDown} />}
                                                </div>
                                            </div>
                                            {openTopics[idxOfKey] &&
                                                results[key].map((problem, idxOfProblem) => {
                                                    return (
                                                        <div className={clsx(styles.gradesBodyContainer)}>
                                                            <div className={clsx('col-5', styles.textPrimary)}>
                                                                {problem.problem_title}
                                                            </div>
                                                            <div className={clsx('col-2', 'textCenter')}>
                                                                {problem.runtime === -1 ? '-' : problem.runtime}
                                                            </div>
                                                            <div className={clsx('col-2', 'textCenter')}>
                                                                {problem.memory === -1 ? '-' : problem.memory}
                                                            </div>
                                                            <div className={clsx('col-1', 'textCenter')}>
                                                                {problem.score === -1 ? '-' : problem.score.toFixed(2)}
                                                            </div>
                                                            <div className={clsx('col-2', 'textCenter')}>
                                                                {problem.runtime === -1
                                                                    ? '-'
                                                                    : lastAccess(problem.datetime)}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>
            )}
            {role === 'teacher' && (
                <div className={clsx(styles.results)}>
                    <div className={clsx(styles.sortBar, 'mt-4')}>
                        <div className={clsx(styles.sortBarSearch)}>
                            <div className={clsx(styles.sortBarSearchIcon)}>
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                            </div>
                            <div className={clsx(styles.sortBarSearchInput)}>
                                <input
                                    type="text"
                                    value={textOfSearch}
                                    placeholder="Search by name..."
                                    className={clsx('form-control', styles.sortBarFormControl)}
                                    onChange={handleChangeSearchInput}
                                    onKeyUp={handleSubmitSearch}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={clsx(styles.resultsTable)}>
                        <div className={clsx('col-4')}>
                            <div className={clsx(styles.userInfo)}>
                                <div
                                    className={clsx(styles.rowHeader, styles.rowHeaderTopLeft, styles.borderHeader)}
                                ></div>
                                <div className={clsx(styles.rowHeader, styles.userInfoHeader)}>
                                    <div className={clsx('col-3', styles.borderHeader)}>ID</div>
                                    <div className={clsx('col-9', styles.borderHeader)}>Full Name</div>
                                </div>
                            </div>
                            {results.body &&
                                Object.keys(results.body).map((userID, idxOfUserID) => {
                                    return (
                                        <div className={clsx(styles.tRow, 'd-flex')}>
                                            <div className={clsx('col-3', styles.borderBody)}>
                                                {results.body[userID].user_id}
                                            </div>
                                            <div className={clsx('col-9', styles.borderBody)}>
                                                {results.body[userID].user_name}
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                        <div className={clsx('col-8', styles.overflow, styles.rowHeaderTopRight)}>
                            <div className={clsx(styles.resultsOfProblemHeader)}>
                                {results.header &&
                                    Object.keys(results.header).map((topic_name, idxOfTopicName) => {
                                        return (
                                            <div className={clsx(styles.headerRight)} key={idxOfTopicName}>
                                                <div
                                                    className={clsx(styles.resultsTopicName, styles.borderHeader)}
                                                    style={{ width: `${results.header[topic_name].length * 200}px` }}
                                                >
                                                    {topic_name}
                                                </div>
                                                <div className={clsx('d-flex')}>
                                                    {results.header[topic_name].map((problem, idxOfProblem) => {
                                                        return (
                                                            <div
                                                                className={clsx(
                                                                    styles.resultsProblemTitle,
                                                                    styles.borderHeader,
                                                                )}
                                                            >
                                                                {problem}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                            {results.body &&
                                Object.keys(results.body).map((userID, idxOfUserID) => {
                                    return (
                                        <div className={clsx(styles.tRow)}>
                                            <div className={clsx('d-flex')}>
                                                {results.body &&
                                                    Object.keys(results.body[userID].problem).map(
                                                        (topic_problem_id, idxOfTopicProblemID) => {
                                                            return (
                                                                <div
                                                                    className={clsx(
                                                                        styles.resultsProblemTitle,
                                                                        styles.borderBody,
                                                                    )}
                                                                >
                                                                    {results.body[userID].problem[topic_problem_id]
                                                                        .score === -1
                                                                        ? '-'
                                                                        : results.body[userID].problem[topic_problem_id]
                                                                              .score}
                                                                </div>
                                                            );
                                                        },
                                                    )}
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const Grades = () => {
    return <CourseComponent state="grades" mainChild={<MainChild />} />;
};

export default Grades;
